const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: "https://cariuska.dev",
  //title: "TC",
};

const about = {
  // all the properties are optional - can be left empty or deleted
  name: "Thiago Cariuska",
  role: "Back End Engineer",
  description:
    "Developer who works in search of results, with excellent communication skills, in addition to deep knowledge in several programming languages, able to learn quickly and apply new technologies.",
  resume: "https://cariuska.dev/Thiago-Cariuska-Resume.pdf",
  social: {
    linkedin: "https://www.linkedin.com/in/thiago-cariuska",
    github: "https://github.com/cariuska",
  },
};

const experience = [
  {
    name: "Tech Lead",
    description: "Analytics by Kaizen",
    stack: ["Porto, Portugal", "-", "11/2022 to Current"]
  },
  {
    name: "Senior Developer",
    description: "Analytics by Kaizen",
    stack: ["Porto, Portugal", "-", "10/2021 to 11/2022"]
  },
  {
    name: "Senior Developer",
    description: "Dock Banking as a Service",
    stack: ["São Paulo / Brasil", "-", "06/2019 to 10/2021"]
  },
  {
    name: "Systems Analysis and Development",
    description: "Virtual Soft Consultoria em Informática",
    stack: ["São Paulo / Brasil", "-", "08/2007 to 06/2019"]
  },
];

const educations = [
  {
    name: "Bachelor's Degree in Information Systems",
    description: "Faculdade Sumaré",
    stack: ["São Paulo / Brasil", "-", "12/2021"]
  },
];

const projects = [];
const projects_ant = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: "Project 1",
    description:
      "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
    stack: ["SASS", "TypeScript", "React"],
    sourceCode: "https://github.com",
    livePreview: "https://github.com",
  },
  {
    name: "Project 2",
    description:
      "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
    stack: ["SASS", "TypeScript", "React"],
    sourceCode: "https://github.com",
    livePreview: "https://github.com",
  },
  {
    name: "Project 3",
    description:
      "Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam",
    stack: ["SASS", "TypeScript", "React"],
    sourceCode: "https://github.com",
    livePreview: "https://github.com",
  },
];

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  ".Net Core",
  "C#",
  "Python",
  "JavaScript",
  "TypeScript",
  "Flutter",
  "React",
  "React Native",
  "Git",
  "CI/CD",
  "MySQL",
  "PostgreSQL",
  "Oracle",
  "Docker",
  "AWS",
  "GCP",
  "RabbitMQ",
  "Redis",
];

const apps = [
  // apps can be added or removed
  // if there are no apps, Apps section won't show up
  {
    name: "Worldwide Radios",
    description: "Listen to thousands of radio stations from around the world",
    logo: "/worldwide-radios/logo.png", // Coloque o caminho correto do logo
    //appStore: "https://apps.apple.com/app/worldwide-radios/id123456789", // Coloque o link correto
    playStore: "https://play.google.com/store/apps/details?id=dev.cariuska.worldwideradios", // Coloque o link correto
  },
  {
    name: "Sudoku",
    description: "Classic Sudoku puzzle game with multiple difficulty levels",
    logo: "/sudoku/logo.png", // Coloque o caminho correto do logo
    //appStore: "https://apps.apple.com/app/sudoku/id123456789", // Coloque o link correto
    playStore: "https://play.google.com/store/apps/details?id=dev.cariuska.sudoku", // Coloque o link correto
  },
  {
    name: "Funny Story",
    description: "Short, crazy and fun stories for kids every day.",
    logo: "/funny-story/logo.png", // Coloque o caminho correto do logo
    //appStore: "https://apps.apple.com/app/sudoku/id123456789", // Coloque o link correto
    playStore: "https://play.google.com/store/apps/details?id=dev.cariuska.funnystory", // Coloque o link correto

  },
  {
    name: "Agendly",
    description: "Appointments, clients and revenue for solo professionals. No internet needed.",
    logo: "/agendly/logo.png", // Coloque o caminho correto do logo
    //appStore: "https://apps.apple.com/app/sudoku/id123456789", // Coloque o link correto
    playStore: "https://play.google.com/store/apps/details?id=dev.cariuska.agendly", // Coloque o link correto

  },
  {
    name: "Personal Life",
    description: "Decorate your home, explore the town, care for your pet. A cozy 3D world.",
    logo: "/personal-life/logo.png", // Coloque o caminho correto do logo
    //appStore: "https://apps.apple.com/app/sudoku/id123456789", // Coloque o link correto
    playStore: "https://play.google.com/store/apps/details?id=dev.cariuska.personallife", // Coloque o link correto

  }
];

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: "tcariuska@gmail.com",
};

export { header, about, projects, educations, experience, skills, contact, apps };
